var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / credit card@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Line",
    transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.417023,13.3539349 L12.6636283,3.60764357 C11.6981631,2.64930399 10.1396404,2.64930399 9.17417524,3.60764357 L3.60385573,9.18456957 C3.37243214,9.41129876 3.19073217,9.68365022 3.07030022,9.98431995 C2.95188762,10.2830955 2.89036303,10.6013438 2.88889012,10.9226937 C2.88856233,11.2452659 2.95391446,11.5645326 3.08097134,11.8610675 C3.19893901,12.1599199 3.38107048,12.4292782 3.61452684,12.6501546 L13.3679215,22.3964459 C14.0564644,23.0839909 15.0876894,23.2976258 15.9930146,22.9402761 C16.2910964,22.8146597 16.5626629,22.6337472 16.7933479,22.4071092 L22.3743385,16.8408466 C22.8301639,16.3835361 23.0936103,15.7692757 23.1106451,15.1240491 C23.1233991,14.4654595 22.8739086,13.8287634 22.417023,13.3539349 Z M16.2064368,21.7033289 C15.9269187,21.9926381 15.5417587,22.1560374 15.1393258,22.1560374 C14.7368929,22.1560374 14.3517329,21.9926381 14.0722148,21.7033289 L4.29747789,11.9250475 C4.04904593,11.6468519 3.91555786,11.284791 3.92398904,10.9120304 C3.9169199,10.7180486 3.95338118,10.5249446 4.03070014,10.3468735 C4.10027655,10.1644773 4.20547256,9.99773621 4.34016233,9.85635989 L7.41344206,6.83863512 L19.2477032,18.6749408 L16.2064368,21.7033289 Z M19.9733387,17.9391704 L8.07505089,6.10286476 L8.73665972,5.39908443 L20.6242764,17.2567168 L19.9733387,17.9391704 Z M21.6807164,16.1903829 L21.3499119,16.5209464 L9.50497965,4.67397741 L9.80377074,4.34341392 C10.0837663,4.05663947 10.4700131,3.89839361 10.8708818,3.90621705 C11.2431281,3.90631741 11.601525,4.04728578 11.8739661,4.30076057 L21.648703,14.0577152 C21.792551,14.1875512 21.9055692,14.3478474 21.9795074,14.5269021 C22.0517149,14.7102243 22.0879139,14.9057189 22.0862185,15.1027224 C22.0960137,15.3028008 22.0632819,15.502683 21.9901785,15.689206 C21.9224117,15.8756562 21.8170864,16.0462315 21.6807164,16.1903829 L21.6807164,16.1903829 Z",
    id: "Shape",
    fill: "#1D1D1B",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.8d8b4710dd8f1e8f42856fca70cba7fa.svg";
export { ForwardRef as ReactComponent };